import React from "react";
import { connect } from "react-redux";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { showToast, getData, putData } from "Source/globalFunction";

@connect(store => {
    return {
        workstreams: store.workstreams,
        loggedUser: store.loggedUser,
        project:  store.project,
    };
})

class Actions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        }
        _.map(["handleClick"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }
    componentDidUpdate(prev){
        if(!_.isEqual(prev.isEdit, this.props.isEdit) && this.props.workstream.id){
            if(this.props.isEdit ===`workstream_edit-${this.props.workstream.id}`) {
                this.setState({...this.state, anchorEl: this.refs[`workstream-${this.props.workstream.id}`]});
            } else {
                this.setState({...this.state, anchorEl:null});
            }
             
        }
    }
   handleClick(event) {
    if(this.props.hasChanges && this.props.hasChanges.length >0) {
        if(this.props.triggerEdit) {
            this.props.triggerEdit({[`workstream_edit-${this.props.workstream.id}`]:true})
            $('#accountSetting').modal("show")
        }

    } else {
        this.setState({...this.state, anchorEl: event.currentTarget});

        if(this.props.onActions) {
            this.props.onActions(true);
        }
    }
        
    }
    render() {
        
        const { workstream, workstreams, dispatch, loggedUser, project } = this.props;
        const open = Boolean(this.state.anchorEl);
       
        
        const handleClose = () => {
            this.setState({...this.state, anchorEl: null});

            if(this.props.onActions) {
                this.props.onActions(false);
            }
        }

        const handleUpdate = () => {
            const responsible =  (workstream.workstreamMembers ||[]).filter(m => m.assign === "responsible");
            
            dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED", selected: {...workstream, ...(responsible.length?{responsible:responsible[0].id}:{}), action: "edit"} });
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "default" });

            handleClose();
            $( "#addWorkstreamModal" ).modal( "show" );
        }

        const handleManageMembers = () => {
            // const url = "/api/workstream/manageMembers";
            const url = `/api/v01/workstreams/${workstream.id}/members`;
            const params = { workstreamId: workstream.id };

            dispatch({type: "SET_SCREEN_LOADER", Loading: true});

            getData(url, {params}, response => {
                if(response) {
                    handleClose();
                    const responseData = response.data?.data?.members || response.data?.data || response.data;

                    dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {...workstream, members: responseData.map(m => ({ ...m, id: m.userId}))}});
                    dispatch({type: "SET_SCREEN_LOADER", Loading: false});

                    $(`#manageMembers`).modal("show");
                }
            });
        }
        const setInactive = () => {
            if(this.props.handleInactive) {
                this.props.handleInactive();
                
                setTimeout(()=>{
                    showToast("success", `Workstream has been set to ${workstream.isActive? 'Inactive':'Active'}`); 
                 }, 500)
            
            } else {
                const url = `/api/workstream/status/${workstream.id}`;
                const params = { isActive: workstream.isActive?0:1 };
    
                dispatch({type: "SET_SCREEN_LOADER", Loading: true});
    
                putData(url, params, response => {
                    if(response) {
                        const workstreamList =workstreams.list.filter(w=>{
                            return w.id !== response.data.id
                        })
                        dispatch({type: "UPDATE_WORKSTREAMS_LIST", list: workstreamList});
                        dispatch({type: "SET_SCREEN_LOADER", Loading: false});
                    }
                    
                    showToast("success", `Workstream has been set to ${workstream.isActive? 'Inactive':'Active'}`);
                });
            }
            
        }

        const handleDelete = () => {
            handleClose();

            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: workstream});

            $(`#deleteWorkstream`).modal("show");
        }
        const enableActions = (loggedUser.data.userRole < 3 || (project.Selected && project.Selected.leadId === loggedUser.data.id ) || workstream.lead.id === loggedUser.data.id);

        if( enableActions ) {
            return (
                <div class="workstreamActions">
                    <a ref={`workstream-${workstream.id}`} onClick={this.handleClick} class={`${open || this.props.isActive ? "active" : ""}`}>
                        <i class="material-icons">more_vert</i>
                    </a>
                    <Popper
                        open={open}
                        anchorEl={this.state.anchorEl}
                        placement="left-start"
                        style={{zIndex: 100}}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <div class="actionsContainer">
                                <div class="actionItem">
                                    <a onClick={handleUpdate}>
                                        <span>Edit Details</span>
                                        <i class="material-icons">create</i>
                                    </a>
                                </div>
                                <div class="actionItem">
                                    <a onClick={handleManageMembers}>
                                        <span>Manage Members</span>
                                        <i class="material-icons">people_outline</i>
                                    </a>
                                </div>
                                <div class="actionItem">
                                    <a onClick={setInactive}>
                                        <span>{`Set To ${workstream.isActive? 'Inactive':'Active'} `}</span>
                                        <i class={`statusIndicator fa fa-circle ${workstream.isActive? 'inactive':'active'}`}></i>
                                    </a>
                                </div>
                                <div class="actionItem deleteWorkstream">
                                    <a onClick={handleDelete}>
                                        <span>Delete Workstream</span>
                                        <i class="material-icons">delete_outline</i>
                                    </a>
                                </div>
                            </div>
                        </ClickAwayListener>
                    </Popper>
                </div>
            );
        }

        return null;
    }
}

export default Actions;